import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import styles from "./TableInput.module.css";

function TableInputs({
  label,
  type,
  name,
  id,
  value = "",
  onChange,
  error,
  placeholder,
  disabled,
  options = [],
  showWordCount = false,
}) {
  const inputType = (type || "").toLowerCase();
  const charCount =
    (inputType === "textarea" || inputType === "text area") &&
    typeof value === "string"
      ? value.length
      : 0;

  const disabledStyles = {
    opacity: 0.5,
    cursor: "not-allowed",
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "38px",
      backgroundColor: "var(--background-color)",
      borderColor: state.isFocused ? "var(--primary-color)" : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.25rem rgba(13,110,253,.25)"
        : "none",
      "&:hover": {
        borderColor: "var(--primary-color)",
      },
      fontSize: "16px",
      fontWeight: 400,
      color: "var(--primary-color)",
      ...(state.isDisabled ? disabledStyles : {}),
    }),
    singleValue: (base) => ({
      ...base,
      color: "var(--primary-color)",
      fontSize: "16px",
      fontWeight: 400,
    }),
    placeholder: (base) => ({
      ...base,
      color: "var(--primary-color)",
      fontSize: "16px",
      fontWeight: 400,
    }),
    input: (base) => ({
      ...base,
      color: "var(--primary-color)",
      fontSize: "16px",
      fontWeight: 400,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      backgroundColor: "var(--background-color)",
      fontSize: "16px",
      fontWeight: 400,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "var(--primary-color)"
        : "var(--background-color)",
      color: state.isFocused
        ? "var(--background-color)"
        : "var(--primary-color)",
      fontSize: "16px",
      fontWeight: 400,
      cursor: "pointer",
    }),
  };

  return (
    <div>
      <Form.Group className="mb-1" controlId={id || name}>
        {label && (
          <Form.Label>
            {label}
          </Form.Label>
        )}

        {inputType === "select" ? (
          <>
            <Select
              name={name}
              id={id}
              value={options.find((opt) => opt.value === value) || null}
              onChange={(selected) =>
                onChange({
                  target: { name, value: selected ? selected.value : "" },
                })
              }
              options={options}
              placeholder={placeholder || "Select an option"}
              isDisabled={disabled}
              styles={customSelectStyles}
            />
            {error && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "0.875em",
                  marginTop: "0.25rem",
                }}
              >
                {error}
              </div>
            )}
          </>
        ) : inputType === "file" ? (
          <>
            <Form.Control
              type="file"
              name={name}
              id={id}
              onChange={onChange}
              isInvalid={!!error}
              disabled={disabled}
              style={disabled ? disabledStyles : {}}
            />
            {placeholder && (
              <Form.Text className="text-muted" style={{ fontSize: "0.8rem" }}>
                {placeholder}
              </Form.Text>
            )}
            {error && (
              <Form.Control.Feedback type="invalid">
                {error}
              </Form.Control.Feedback>
            )}
          </>
        ) : (
          <>
            {/* <Form.Control
              as={
                inputType === "textarea" || inputType === "text area"
                  ? "textarea"
                  : "input"
              }
              type={
                inputType !== "textarea" && inputType !== "text area"
                  ? inputType
                  : undefined
              }
              name={name}
              id={id}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              isInvalid={!!error}
              disabled={disabled}
              inputMode={inputType === "number" ? "numeric" : undefined}
              pattern={inputType === "number" ? "\\d*" : undefined}
              onWheel={(e) => inputType === "number" && e.target.blur()} // ✅ Disable scroll to increment
              maxLength={
                showWordCount &&
                (inputType === "textarea" || inputType === "text area")
                  ? 1500
                  : undefined
              }
              style={{
                ...(inputType === "textarea" || inputType === "text area"
                  ? { height: "100px" }
                  : {}),
                ...(disabled ? disabledStyles : {}),
              }}
            /> */}
            <div className="form-control-wrapper">
              <Form.Control
                as={
                  inputType === "textarea" || inputType === "text area"
                    ? "textarea"
                    : "input"
                }
                type={
                  inputType !== "textarea" && inputType !== "text area"
                    ? inputType
                    : undefined
                }
                name={name}
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                isInvalid={!!error}
                disabled={disabled}
                inputMode={inputType === "number" ? "numeric" : undefined}
                pattern={inputType === "number" ? "\\d*" : undefined}
                onWheel={(e) => inputType === "number" && e.target.blur()}
                maxLength={
                  showWordCount &&
                  (inputType === "textarea" || inputType === "text area")
                    ? 1500
                    : undefined
                }
                style={{
                  ...(inputType === "textarea" || inputType === "text area"
                    ? { height: "100px", paddingRight: "60px" } // add padding for count
                    : {}),
                  ...(disabled ? disabledStyles : {}),
                }}
              />
              {showWordCount && (
                <div className="word-count">
                  {value.length}/
                  {inputType === "textarea" || inputType === "text area"
                    ? 1500
                    : ""}
                </div>
              )}
            </div>
{/* 
            {showWordCount &&
              (inputType === "textarea" || inputType === "text area") && (
                <div className={styles.mobilePosition}>{charCount}/1500</div>
              )} */}

            {error && (
              <Form.Control.Feedback type="invalid">
                {error}
              </Form.Control.Feedback>
            )}
          </>
        )}
      </Form.Group>
    </div>
  );
}

export default TableInputs;
